import { getAxiosInstance } from '../client';
/** Typed API functions for user diagnosis and anamneses */
export const diagnosisQueries = {
    /** GET /users/:userId/diagnosis */
    getUserDiagnosis: (userId) => getAxiosInstance()
        .get(`/users/${userId}/diagnosis`)
        .then((r) => r.data),
    /** GET /users/:userId/anamneses */
    getUserAnamneses: (userId) => getAxiosInstance()
        .get(`/users/${userId}/anamneses`)
        .then((r) => r.data),
};
export const diagnosisKeys = {
    all: () => ['diagnosis'],
    userDiagnosis: (userId) => ['diagnosis', 'user', userId],
    userAnamneses: (userId) => ['diagnosis', 'anamneses', userId],
};
//# sourceMappingURL=diagnosis.queries.js.map